import { render } from "./BulkEmailCampaign.vue?vue&type=template&id=7701404e&scoped=true"
import script from "./BulkEmailCampaign.vue?vue&type=script&lang=js"
export * from "./BulkEmailCampaign.vue?vue&type=script&lang=js"

import "./BulkEmailCampaign.vue?vue&type=style&index=0&id=7701404e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7701404e"]])

export default __exports__